<template>
    <div style="width: 1220px; margin: 0px auto">
        <div style="padding-top: 20px;display: flex">
            <left-menu></left-menu>
            <div class="usercontainer">

               <div class="userheader">
                   用户基本信息
               </div>
                <el-form  :rules="classFormCheck"  :model="userinfo" ref="userinfo" style="padding: 20px 130px 20px 0px">
                    <el-form-item
                            label="用户名"
                            prop="account"
                            label-position="left"
                            label-width="140px">
                        <el-input
                                class="input"
                                v-model="userinfo.account"
                                disabled
                                auto-complete="off" />
                    </el-form-item>
                    <el-form-item
                            label="手机号码"
                            prop="mobile"
                            label-position="left"
                            label-width="140px">
                        <el-input
                                class="input"
                                disabled
                                v-model="userinfo.mobile"
                                auto-complete="off" 
                                style="width:85%"/>
                        <el-button type="primary" plain style="margin-left:10px" @click="openMobile">修改手机号</el-button>
                    </el-form-item>
                    <el-form-item
                            label="电子邮箱"
                            prop="email"
                            label-position="left"
                            label-width="140px">
                        <el-input
                                class="input"
                                v-model="userinfo.email"
                                auto-complete="off" />
                    </el-form-item>
                    <el-form-item
                            label="身份证号"
                            prop="number"
                            label-position="left"
                            label-width="140px">
                        <el-input
                                class="input"
                                v-model="userinfo.certficate_number"
                                auto-complete="off" />
                    </el-form-item>
                    <el-form-item
                            label="真实姓名"
                            prop="name"
                            label-position="left"
                            label-width="140px">
                        <el-input
                                class="input"
                                v-model="userinfo.real_name"
                                auto-complete="off" />
                    </el-form-item>

                </el-form>
                <div class="formfooter">
                    <el-button type="primary" @click="changeUserinfo" size="large">
                        保存
                    </el-button>
                </div>

                <el-dialog v-model="dialogVisible" title="修改手机号码"  :append-to-body="true" width="500px">
                    <div >
                        <el-form  :rules="classFormCheck"  :model="mobileinfo" ref="mobileinfo" label-width="80px">
                            <el-form-item
                                    label="手机号码"
                                    prop="mobile"
                                    label-position="left"
                                    >
                                <el-input
                                        class="input"
                                        v-model="mobileinfo.mobile"
                                        auto-complete="off" />
                            </el-form-item>
                            <el-form-item
                                    label="验证码"
                                    prop="code"
                                    label-position="left">
                                <el-input
                                        class="input"
                                        v-model="mobileinfo.code"
                                        auto-complete="off" 
                                        style="width:72%"/>
                                <span class="codeBtn" @click="getCode">{{codetime ? time : '获取验证码'}}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <template #footer >
                            <el-button type="primary" @click="changeMobile">提交</el-button>
                            <el-button @click="closeMobile">取消</el-button>
                        </template>
                </el-dialog>
            </div>
        </div>

    </div>

</template>

<script>
    import userInfo from "../../api/userInfo";
    import leftMenu from "../../components/LeftMenu";

    export default {
        name: "AboutUs",
        components:{
            leftMenu
        },

        data() {
            let phoneRules = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入手机号码'))
                } else {
                    const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
                    if (reg.test(value)) {
                        callback()
                    } else {
                        return callback(new Error('请输入正确的电话'))
                    }
                }
            };
            let cardRules = (rule, value, callback) => {
                    if (value) {
                        const val = /(^\d{15}$)|(^\d{17}(\d|X)$)/;

                        if (val.test(value)) {
                            callback()
                        } else {
                            return callback(new Error('请输入正确的证件号码'))
                        }
                    }else{
                        callback()
                    }
                }
            return {
                userinfo:{},
                dialogVisible:false,
                mobileinfo:{},
                codetime:false,
                time:60,
                classFormCheck: {
                    account:[
                        {
                            required: true,
                            message: "请输入姓名",
                            trigger: "blur",
                        },
                    ],
                    mobile: [
                        {validator: phoneRules, trigger: 'blur', required: true,}
                    ],
                    email: [
                        {
                            required: true,
                            message: "请输入电子邮箱",
                            trigger: "blur",
                        },
                    ],
                    code: [
                        {
                            required: true,
                            message: "请输入验证码",
                            trigger: "blur",
                        },
                    ],
                    number: [
                        {validator: cardRules, trigger: 'blur'}
                    ]
                },
            }
        },
        created() {
            this.getUserinfo();
        },
        methods: {
            changeMobile(){
                this.$refs.mobileinfo.validate((valid) => {
                    if (valid) {
                        userInfo.changeUserinfo(this.mobileinfo).then(res => {
                            if (res.data.code === 200) {
                                userInfo.getUserinfo().then(res1 => {
                                    if (res1.data.code === 200) {
                                        if(res1.data.data.mobile){
                                            localStorage.setItem('mobile',res1.data.data.mobile)
                                        }
                                    }
                                    
                                });
                                this.$alert(res.data.detail, "", {
                                    confirmButtonText: "确定",
                                    callback: () => {

                                    },
                                });
                            }else{
                                this.$alert(res.data.detail, "", {
                                    confirmButtonText: "确定",
                                    callback: () => {

                                    },
                                });
                            }
                            this.closeMobile();

                        });

                    } else {
                        return false;
                    }
                });
            },
            getCode(){
                this.$refs.mobileinfo.validateField('mobile', emailError => {
                    if (emailError==true ) {
                        this.codetime=true;
                         this.time=60;
                         userInfo.saveMobileByCode({mobile:this.mobileinfo.mobile}).then(res => {
                            if (res.data.code == 200) {
                                this.timer = setInterval(() => {
                                    this.time--
                                    if (this.time === 0) {
                                        clearInterval(this.timer) // 清除定时器
                                        this.codetime=false
                                    }
                                }, 1000);
                            } else {
                                this.$alert(res.data.detail, "", {
                                    confirmButtonText: "确定",
                                    callback: () => {
                                        this.codetime=false;
                                        this.time=60;
                                    },
                                });
                            }

                        })

                    } else {

                        return false;
                    }
                });
            },
            openMobile(){
                this.dialogVisible = true;
                this.mobileinfo = {};
            },
            closeMobile(){
                this.dialogVisible = false;
                this.$refs.mobileinfo.clearValidate();
            },
            changeUserinfo(){
                this.$refs.userinfo.validate((valid) => {
                    if (valid) {
                        userInfo.changeUserinfo(this.userinfo).then(res => {
                            if (res.data.code === 200) {
                                userInfo.getUserinfo().then(res1 => {
                                    if (res1.data.code === 200) {
                                        if(res1.data.data.email){
                                            localStorage.setItem('email',res1.data.data.email)
                                        }
                                        if(res1.data.data.mobile){
                                            localStorage.setItem('mobile',res1.data.data.mobile)
                                        }
                                    }
                                });
                            this.$alert(res.data.detail, "", {
                                    confirmButtonText: "确定",
                                    callback: () => {

                                    },
                                });
                             }


                        });

                    } else {
                        return false;
                    }
                });
            },
            getUserinfo(){
                userInfo.getUserinfo().then(res => {
                    if (res.data.code === 200) {
                        this.userinfo=res.data.data;

                    }


                });
            }

        }
    }
</script>

<style scoped lang="less">
.codeBtn{
  color: #409EFF;
  font-size: 12px;
  cursor: pointer;
  background-color: #ECF5FF;
  border: 1px solid #A0CFFF;
  border-radius: 5px;
  width: 90px;
  text-align: center;
  margin-left: 14px;
}
</style>